import React from 'react'
import { withRouter } from 'react-router'
import EnterpriseContract from '../components/enterprise/contract'
import EnterpriseContractProfile from '../components/enterprise/contract/profile'

class EnterpriseContractPage extends React.Component {
    render(){
      const {customerId} = this.props.match.params

      if (customerId) {
        return (<EnterpriseContractProfile customerId={customerId}/>)
      }

      return(
          <EnterpriseContract/>
      )
    }
}

export default withRouter(EnterpriseContractPage)


// WEBPACK FOOTER //
// ./src/containers/enterprise-contract-page.js